import $ from 'jquery';
import {Model} from 'backbone';
import eventBus from 'EventBus.js';
import util from 'util/Util';
import BaseDashboardLeftPanelView from 'dashboard/BaseDashboardLeftPanelView.js';
import RestService from 'RestService';
import NotificationService from 'NotificationService.js';

import ViewReportsDashboardView from 'dashboard/reports/EditReportsDashboardView.js';
import EditReportsDashboardView from 'dashboard/reports/ViewReportsDashboardView.js';

import ViewableInstanceDetailView from 'dashboard/forms/ViewableInstanceDetailView.js'
import reportAddService from 'ReportAddService.js';
import ReportDetailsView from 'dashboard/reports/ReportDetailsView.js'
import ReportDetailsModel from 'ReportDetailsModel.js';
import singleItemTemplate from 'dashboard/single-item.ejs';
import constants from 'Constants.js';
import undoService from 'UndoService';
import textConstants from 'TextConstants';
import listService from 'ListService.js';
import userService from 'UserService.js';
import reportFolderService from 'ReportFolderService.js';
import ImportModal from 'common-views/ImportModalView.js';
import restMessages from 'RestMessages';
import ReportDeleteModal from 'dashboard/reports/modal/ReportDeleteModal.js';

const ICON_FOLDER = constants.DB_ICON_FOLDER;
const ICON_FOLDER_ACCOUNT = constants.DB_ICON_FOLDER_ACCOUNT;
const ICON_EMPTY = constants.DB_ICON_EMPTY;

class ReportLeftPanelView extends BaseDashboardLeftPanelView {


    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};

        this.sections = {
            PRIVATE_REPORTS: 'PrivateReports',
            SHARED_REPORTS: 'SharedReports'
        };

        // Most Events Should be at Base
        //this.events = {};
        this.bounceDelay = 500;

        listService.avoidDoubleClickOnDashboardTree = false;

        this.isBULicense = util.isTrue(listService.accountSettings.IsBULicense);
        this.enableReports = util.isTrue(userService.checkFeatures('Report'));

        // structure to load List
        let sections = {sections: []};

        if (!this.isBULicense || (this.isBULicense && this.enableReports)) {
            sections.sections.push(
                {
                    sectionName: 'Edit Reports',
                    sectionType: 'sectionEditReports',
                    groupType: 'section',
                    id: constants.REPORTS_VIEW_GROUP_TYPE,
                    nodeType: 'editReports',
                    groups: [
                        {
                            groupName: 'Private',
                            nodeType: 'PrivateReports',
                            id: constants.REPORTS_PRIVATE_GROUP_TYPE,
                            nodes: []
                        },
                        {
                            groupName: 'Shared',
                            nodeType: 'SharedReports',
                            id: constants.REPORTS_SHARED_GROUP_TYPE,
                            nodes: []
                        }
                    ]
                });
            sections.sections.push({
                sectionName: 'View Reports',
                sectionType: 'sectionViewReports',
                groupType: 'viewReports',
                id: constants.REPORTS_VIEW_GROUP_TYPE,
                nodeType: 'viewReports',
                groups: [],
                nodes: []
            });
        }

        this.listenTo(eventBus, constants.SWITCH_DETAIL_REPORT, this._onDetailReportSwitch);
        this.listenTo(eventBus, 'createNewReport', this.createNew);
        this.listenTo(eventBus, 'shareReport', this.shareReport );
        this.listenTo(eventBus, 'unShareReport', this.unShareReport);
        this.listenTo(eventBus, 'deletingReport', this._onDeletingReport);
        this.listenTo(eventBus, 'unDeletingReport', this.notifyNewReport);
        this.listenTo(eventBus, constants.EV_UNDELETE_REPORT, this.onUnDeleteReport);
        this.listenTo(eventBus, 'undoReportFolder', this.undoReportFolder);
        this.listenTo(eventBus, constants.EV_UPDATE_REPORT_DETAILS, this.renderReportDetails);
        this.listenTo(eventBus, 'deployReport', this.renderReportDetails);
        this.listenTo(eventBus, 'relatedReport', this.renderReportDetails);
        this.listenTo(eventBus, constants.DASHBOARD_REPORTS_LOADED, this._createAutocomplete);
        this.listenTo(eventBus, 'refreshReportDetails', this.renderReportDetails);
        this.listenTo(eventBus, constants.EV_REFRESH_PRIVATE_REPORT_NODES, this.loadPrivateOrSharedReports);
        this.listenTo(eventBus, constants.EV_REFRESH_EDIT_REPORT_FOLDER, this.renderEditReportFolderNodes);
        this.listenTo(eventBus, constants.EV_REFRESH_VIEW_REPORTS, this.renderViewReportNodes);
        this.listenTo(eventBus, constants.EV_REFRESH_VIEW_REPORT_FOLDER, this.renderViewReportFolderNodes);
        this.listenTo(eventBus, constants.EV_REFRESH_REPORT_MAIN_VIEW_DETAILS, this.refreshReportsMainView);
        this.listenTo(eventBus, "undeletingReportFolder", this.undeletedReportFolder);
        this.listenTo(eventBus, 'resettingReport', this.renderReportDetails );

        this.isPrivateSectionSelected = true;
        this.model.set('reportSections', sections, {silent: true});
        this.model.set('currentActiveSection', 'reportSections', {silent: true});

        this.renderReportDetailsDebounced = _.debounce((reportId, groupType, itemId,parentId, isPrivate)=>{
            if($('#dashboard-left-panel .item-link').is(':disabled')===false) {
                util.disableReloadLink();
                RestService.getReportDetails(reportId).then((reportDetailsResult) => {
                    util.enableReloadLink();
                    this.killDetailView();
                    //eventBus.off(constants.EV_UPDATE_REPORT_DETAILS);

                    const reportDetailsData = reportDetailsResult.RESULT.RESPONSE.PrivateReportDetails;
                    let permissionList = [];
                    let dependenceList = [];

                    // Adding Permissions to an array if any
                    if (reportDetailsData['PermissionsXML']) {
                        permissionList = reportDetailsData['PermissionsXML'].Permissions.User instanceof Array
                            ? reportDetailsData['PermissionsXML'].Permissions.User
                            : [reportDetailsData['PermissionsXML'].Permissions.User];
                    }
                    // Adding Dependences to an array if any
                    if (reportDetailsData['Dependencies']) {
                        let tmpDependenceList = reportDetailsData['Dependencies'].Dependency instanceof Array
                            ? reportDetailsData['Dependencies'].Dependency
                            : [reportDetailsData['Dependencies'].Dependency];
                        dependenceList = _.sortBy(tmpDependenceList,['@type', '@name']);
                    }

                    // Filling the model with data coming from API.
                    let reportDetailsModel = new ReportDetailsModel();
                    const userProfile = RestService.getProfile();
                    reportDetailsData.IsPrivate = isPrivate !== undefined ? isPrivate : userProfile.UserId === reportDetailsData.OwnerId && groupType !== constants.REPORTS_SHARED_GROUP_TYPE;

                    // PF-2307
                    reportDetailsModel.set('ownerId', reportDetailsData.OwnerId);
                    reportDetailsModel.set('ownerName', reportDetailsData.OwnerName);

                    reportDetailsModel.set('reportName', reportDetailsData.Name);
                    reportDetailsModel.set('currentReportName', reportDetailsData.Name);
                    reportDetailsModel.set('dateCreated', util.getFormattedDate(reportDetailsData.CreatedDate));
                    reportDetailsModel.set('lastUpdate', util.getFormattedDate(reportDetailsData.LastUpdate));
                    reportDetailsModel.set('lastUpdateUTC', util.formatUTC(reportDetailsData.LastUpdate));
                    reportDetailsModel.set('latestVersion', reportDetailsData.Version);
                    reportDetailsModel.set('viewedBy', permissionList);
                    reportDetailsModel.set('deployedVersion', reportDetailsData.DeployVersion);
                    reportDetailsModel.set('isActive', reportDetailsData.IsActive === 'True' ? true : false);
                    reportDetailsModel.set('currentIsActive', reportDetailsData.IsActive === 'True' ? true : false);
                    reportDetailsModel.set('version', 'latest');
                    reportDetailsModel.set('reportId', reportId);
                    reportDetailsModel.set('parentId', parentId);
                    reportDetailsModel.set('versionList', reportDetailsData.VersionList.Version);

                    reportDetailsModel.set('permissionList', _.cloneDeep(permissionList));
                    reportDetailsModel.set('currentPermissionList', _.cloneDeep(permissionList));

                    reportDetailsModel.set('dependenceList', Object.assign([],dependenceList));

                    reportDetailsModel.set('LinkId', reportDetailsData.LinkId);
                    reportDetailsModel.set('parentId', parentId);
                    reportDetailsModel.set('Width', reportDetailsData.Width);
                    reportDetailsModel.set('Height', reportDetailsData.Height);
                    reportDetailsModel.set('IsDeployed', reportDetailsData.IsDeployed);
                    reportDetailsModel.set('GroupId', reportDetailsData.GroupId || itemId);
                    reportDetailsModel.set('IsPrivate', reportDetailsData.IsPrivate);
                    reportDetailsModel.set('groupType', groupType);
                    reportDetailsModel.set('hasChanges', false);
                    reportDetailsModel.set('responsive', reportDetailsData.IsResponsive);
                    reportDetailsModel.set('containsMobileErrors', reportDetailsData.ContainsMobileErrors);
                    reportDetailsModel.set('LastRecoveryUpdateDate', reportDetailsData.LastRecoveryUpdateDate);

                    // Configure Title and Breadcrumbs
                    var breadcrumbs = [
                        {name: 'Home', route: '#reports'},
                        {name: 'Reports', route: '#reports'}
                    ];

                    // reportDetailsModel.set('dashboardTitle', 'Edit Report');
                    reportDetailsModel.set('dashboardTitle', groupType !== constants.REPORTS_SHARED_GROUP_TYPE
                        ? `Report - ${reportDetailsData.Name}` : `Shared Report - ${reportDetailsData.Name}`);
                    reportDetailsModel.set('breadcrumbs', breadcrumbs);
                    // **************************

                    listService.reportItemSelected = {reportName:reportDetailsData.Name,reportId:reportId,reportLink:reportDetailsData.LinkId,
                        versionList:reportDetailsData.VersionList.Version,groupType:groupType,groupId:reportDetailsData.GroupId || itemId};

                    const refreshButton = $('#pf-refresh-main-view'); //reset id in refresh button
                    refreshButton.attr("data-appid", reportId);    

                    let newReportDetailsView = new ReportDetailsView({model: reportDetailsModel, el: constants.DASHBOARD_MAIN_PANEL});
                    listService.dashboardLayout.mainPanelView = newReportDetailsView;
                    this.detailView = newReportDetailsView;
                    this.detailView.render();
                }, error => {
                    util.enableReloadLink();
                    console.log(restMessages.codeToMessage(error.code));
                });
            }
        }, this.bounceDelay, {leading:true, trailing:false});

        return this;
    }

    // PF-3608 Autocomplete Widget that search for reports given a respective term.
    _createAutocomplete(ev) {
        const self = this;
        let cache = {};

        if (!this.isBULicense || (this.isBULicense && this.enableReports)) {
            $("#formReportSearch").autocomplete({
                delay: 1000,
                focus: function (event, ui) {
                    $("#formReportSearch").val(ui.item['@name']);
                    return false;
                },
                source: function (request, response) {
                    let term = request.term;
                    if (term in cache) {
                        response(cache[term]);
                        return;
                    }
                    RestService.searchReportByName(term).then(results => {
                        if (results.RESULT.RESPONSE.Group) {
                            const items = results.RESULT.RESPONSE.Group.Item instanceof Array ?
                                results.RESULT.RESPONSE.Group.Item :
                                [results.RESULT.RESPONSE.Group.Item];
                            cache[term] = items;
                            response(items);
                        } else {
                            response([]);
                        }
                    }, err => {
                        NotificationService.error('Error while searching reports:', err);
                        console.log(`Error while searching reports:`, err);
                    })
                },
                select: function (event, ui) {
                    self.renderReportDetails(ui.item["@id"]);
                }
            }).autocomplete("instance")._renderItem = function (ul, item) {
                return $("<li>")
                    .append("<div formId='" + item["@id"] + "' groupId='" + item["@GroupId"] + "'>" + item['@name'] + "</div>")
                    .appendTo(ul);
            };
        }
        else{
            $(".search-box").hide();
            $(".action-buttons").hide();
        }
    }

    //=========================================================================================================
    // Ensures that Edit Reports -> Private subtree is expanded
    // This call returns after triggering asynchronouse REST calls that step the authentication token.
    // PF-2422
    //=========================================================================================================
    static expandTreeReportsPrivate() {

        $(constants.EDIT_FORMS_SECTION_CONTAINER).collapse('show');
        $(constants.EDIT_FORMS_CONTAINER).collapse('show');
    //     const
    //         $selHeading = $(`div[data-target*='#well_1']`),
    //         $selPrivate = $(`a[data-target*='#well_2']`),
    //         classCollapsed = 'collapsed';

    //     if ($selHeading.hasClass(classCollapsed)) {
    //         $selHeading.click();
    //     }
    //     if ($selPrivate.hasClass(classCollapsed)) {
    //         $selPrivate.click();
    //     }
     }

     static expandTreeReportsShare(nodeTarget) {
        $(constants.EDIT_FORMS_SECTION_CONTAINER).collapse('show');
        $(constants.SHARED_FORMS_CONTAINER).collapse('show');
        $(nodeTarget).collapse('show');
     }

    //=========================================================================================================
    // Expand left-hand panel subtree, add report to system, notify user, then paint the report details in the
    // right-hand panel.
    // Note: undo / redo no longer handled in this method.
    //=========================================================================================================
    createNew(ev) {
        const treeOpenSlack = 1000;
        const _this = this;
        let target = ev.target.id;

        let element = document.getElementById(target);

        element.disabled = true;
        element.className = 'l\i-disabled';

        // Flag to differentiate between a new form created so Dashboards are not loaded on the click performed
        // by notifyNewReport.
        this.model.set('isNew',true,{silent:true});

       
        // Paint report details in separate browser turn.

        window.setTimeout(() => {
            let setCreateNewLink = (disabled = false, className = '') => {
                element.disabled = disabled;
                element.className = className;
            }

            reportAddService.newReport(this.selectedGroupParentId, this.selectedGroupType, this.selectedNodeOnTree,
                                    this.selectedNodeTarget,
                                    reportAddService.defaultReport,
                                    constants.DEFAULT_REPORT_NAME,
                                    this.isPrivateSectionSelected).then( result => {

                let nodeTarget = this.selectedNodeTarget || constants.EDIT_FORMS_CONTAINER;
                let sectionType = this.selectedNodeType || constants.REPORTS_PRIVATE_SECTION;
                if(this.selectedNodeType === constants.REPORTS_SHARED_SECTION 
                    && this.selectedGroupParentId === constants.DEFAULT_GROUP_ID ){
                    nodeTarget = $( `[data-itemId="${result.groupType}"`)[0].getAttribute('data-target');
                }

                if ($(nodeTarget).is(':visible') || !$(nodeTarget).is(':hidden')){
                    _this.notifyNewReport(result, this.selectedNodeOnTree, nodeTarget);
                    setCreateNewLink();
                }else{
                    this.browseAndExpandnode(result, nodeTarget, sectionType);
                    setCreateNewLink();
                }
               
            }, error => {
                setCreateNewLink();
                listService.avoidDoubleClickOnDashboardTree = false;
                NotificationService.error(error);
            }).catch( errMsg => {
                NotificationService.error(errMsg);
                listService.avoidDoubleClickOnDashboardTree = false;
                setCreateNewLink();
            });

        }, treeOpenSlack);

    }

    browseAndExpandnode(result, nodeTarget, sectionType){
        let groupTypeId = this.selectedGroupType ? this.selectedGroupType : !result.groupType ? constants.REPORTS_PRIVATE_GROUP_TYPE : constants.REPORTS_SHARED_GROUP_TYPE;
        let groupId =  !result.groupType ? constants.DEFAULT_GROUP_ID : result.groupType;
        
        RestService.getReportsByGroupType(groupTypeId, groupId).then( data => {
            const reports = data.RESULT.RESPONSE.Group;
            if (reports) {
                const nodes = this.loadNodesFromResponse(reports, groupTypeId);

                const group = this.replaceGroupItemsInModel('reportSections', 'Edit Reports', groupTypeId, nodes);
                this.addItemsToGroup(group, nodeTarget);
                this.selectedNodeOnTree = group.id;
                this.selectedNodeTarget = nodeTarget;
                this.selectedGroupType = groupTypeId;
                this.selectedGroupParentId = constants.DEFAULT_GROUP_ID;
                this.selectedNodeType = sectionType;
                this.selectedNodeParentId = constants.DEFAULT_GROUP_ID;
            }

            listService.avoidDoubleClickOnDashboardTree = false;

            this.notifyNewReport(result, this.selectedNodeOnTree, nodeTarget, false);

            if(groupTypeId === constants.REPORTS_PRIVATE_GROUP_TYPE){
                ReportLeftPanelView.expandTreeReportsPrivate();
            }else{
                ReportLeftPanelView.expandTreeReportsShare(nodeTarget);
            }
            $(`[data-itemid="${result.groupTypeId}_${result.reportId}"]`).closest('li').addClass('bg-success');

        }, error => {
            var code = error.CODE || error;
            listService.avoidDoubleClickOnDashboardTree = false;
            NotificationService.error(restMessages.codeToMessage(code));
        }).catch( error => {
            var msg = error || 'Unknown Error';
            listService.avoidDoubleClickOnDashboardTree = false;
            NotificationService.error(msg);
        });
    }

    deleteReport(reportId){
        return RestService.deleteReport(reportId);
    }

    notifyNewReport( report,selectedNodeOnTree, selectedNodeTarget, addNode = true ) {
        if (report.msg) {
            NotificationService.success( report.msg );
        }
        let nodeTarget = selectedNodeTarget;
        if (!this.selectedNodeTarget) {
            this.selectedNodeTarget = nodeTarget = report.nodeTarget;
        }

        $(report.nodeTarget).collapse('show');
        
        if(report && !report.groupType && report.groupTypeId !== constants.REPORTS_SHARED_GROUP_TYPE){
            report.groupTypeId =constants.REPORTS_PRIVATE_GROUP_TYPE;
        }else{
            report.groupTypeId = constants.REPORTS_SHARED_GROUP_TYPE;
        }

        const newNode = { node: {
            id: `${report.groupTypeId}_${report.reportId}`,
            groupType: report.groupTypeId,
            icon: ICON_EMPTY,
            nodeType: 'attn',
            nodeName: report.name,
            toggleIcon: '',
            selected: true,
            parentId:report.parentId}
        };

        // clear other selections
        $('li[role="button"]').removeClass('bg-success');
        $('div').removeClass('bg-success');

        let targetToAddItem = null;
        
        if (report.groupTypeId === constants.REPORTS_SHARED_GROUP_TYPE) {
            targetToAddItem = $(nodeTarget + ' ul:first ');
        }
        else {
            targetToAddItem = report.nodeTarget === constants.EDIT_FORMS_CONTAINER || !report.nodeTarget ?
                $(constants.EDIT_FORMS_CONTAINER + ' ul:first ') :  $((report.nodeTarget || this.selectedNodeTarget) + ' UL');
        }

        if( targetToAddItem.children() && $(targetToAddItem.children()[0]).text().trim()=== 'no items'){
            $(targetToAddItem.children()[0]).remove();
        }

        // Insert Node into Tree
        if(addNode){
            if (nodeTarget) {
                $(nodeTarget + ' ul:first ').append( singleItemTemplate( newNode ) );
            }
            else {
                $(targetToAddItem).append( singleItemTemplate( newNode ) );
            }
        }    

        this.renderReportDetails(report.reportId, report.groupTypeId || selectedNodeOnTree, `${report.reportId}_${report.groupTypeID}`);

        super.makeDraggables();
    }

    addNewReportOnTree( report ){
        NotificationService.success( report.msg );
        $(report.nodeTarget).collapse('show');
        const newNode = { node: {
                id: `${this.selectedNodeOnTree}_${report.reportId}`,
                groupType: report.groupTypeId || this.selectedNodeOnTree,
                icon: ICON_EMPTY,
                nodeType: 'attn',
                nodeName: report.name,
                toggleIcon: '',
                selected: true,
                parentId:report.parentId}
        };

        // clear other selections
        $('li[role="button"]').removeClass('bg-success');
        $('div').removeClass('bg-success');

        let targetToAddItem = report.nodeTarget === constants.EDIT_FORMS_CONTAINER ?
            $(constants.EDIT_FORMS_CONTAINER + ' UL'):
            $((report.nodeTarget || this.selectedNodeTarget) + ' UL');

        if( $(targetToAddItem.children()[0]).text().trim()=== 'no items'){
            $(targetToAddItem.children()[0]).remove();
        }

        // Insert Node into Tree
        $(targetToAddItem).first().append( singleItemTemplate( newNode ) );

        super.makeDraggables();
    }

    onUnDeleteReport(reportObject,reportId,groupType,groupId,dataTarget){
        this.addNewReportOnTree(reportObject);
        this.renderReportDetails(reportId,groupType,groupId,dataTarget);
    }

    _onDetailReportSwitch(event) {
        if (event.detailPage === 'ViewableInstanceDetailView') {
            this.renderViewableInstanceDetailView(event.payload.instanceId);
            // Finding the element so we can select it.
            let element = $(`a[data-itemid="${event.payload.instanceId}"]`);
            if (element) {
                // Removing previous selections.
                this.removeItemGroupSelection();

                // Selecting element.
                this.addItemGroupSelection(element);
            }
        }
    }

    _onDeletingReport(reportId, isFolder = false,name) {
        // Look for the li and remove it
        const element = $('a[data-itemid$="' + reportId + '"]');
        const dataTarget = element.attr('data-target');
        element.parent().remove();

        //In case it is a directory
        let details = $(dataTarget);
        if (details) {
            details.remove();
        }

        this.renderReportsDashboard(null,'edit');
        if (!isFolder) {
            NotificationService.success(`Deleted report ${name} Clicking undo restores it.`);
        }
        else{
            NotificationService.success(`Deleted folder Clicking undo restores it.`);
        }
    }

    handleExpand(ev) {
        try {
            ev && ev.preventDefault();
            this.attachRightClickMenu();
            this.contextMenus && typeof this.contextMenus.close === 'function' && this.contextMenus.close();
        } catch (e) {

        }
        
         if (listService.avoidDoubleClickOnDashboardTree) {
            return;
        }

        listService.avoidDoubleClickOnDashboardTree = true;

        let eventTarget = $(ev.target);
        this.checkForEnablingViewReportsMenu(eventTarget);
        let isFormWithNoChildren = (eventTarget.attr('data-nodetype') === 'attn' && eventTarget.attr('data-haschildren') === 'false') || eventTarget.attr('title') === 'no items';
        if (isFormWithNoChildren) {
            return;
        }

        let className;

        let itemSelected = $(ev.currentTarget).closest('div').find('.bg-success');
         if (itemSelected.length > 0){
             listService.reportItemSelected = undefined;
         }

        let itemId = ev.currentTarget.attributes['data-itemid'].value;
        let groupType = ev.currentTarget.attributes['data-groupType'].value;
        let nodeType = ev.currentTarget.attributes['data-nodeType'].value;

        if (nodeType === 'group') {
            listService.reportItemSelected = {
                reportId: itemId,
                reportName: eventTarget.text(),
                groupId: '',
                groupType: groupType,
                nodeType: nodeType
            };
        }
        this.selectedGroupType = groupType === 'section' ? constants.REPORTS_PRIVATE_GROUP_TYPE : groupType;

        if ((eventTarget.parents('#well_4').length > 0 || eventTarget.parents('#well_5').length > 0) && !eventTarget.is('i')) {
            let closestIcon = eventTarget.siblings('i');
            className = closestIcon.attr('class');
        }
        else
        {
            className = ev.currentTarget.className;
        }

        // don't process on the collapse
        if (new RegExp('collapsed').test(className)) {
            const _none = () => {
                this.handleSection(ev);
            };

            const _group = () => {

                let dataTarget = ev.currentTarget.attributes['data-target'].value;
                let currentTargetObj = $(ev.currentTarget);
        
                if(currentTargetObj.hasClass('document-heading')){
                    util.togglePanel(currentTargetObj.find('.switch'), currentTargetObj.find('i'));
                }
                else{
                    //In this case the target is the same as the icon
                    util.togglePanel(currentTargetObj, currentTargetObj);
                }
                

                RestService.getReportsByGroupType(groupType, itemId).then((data) => {
                    let reports = data.RESULT.RESPONSE.Group;

                    let nodes = [];
                    if (reports) {
                        nodes = this.loadNodesFromResponse(reports, groupType,itemId);
                    } else {
                        nodes = [{
                            nodeName: 'no items',
                            url: '#',
                            icon: ICON_EMPTY,
                            id: 0,
                            groupType: groupType,
                            nodeType: '',
                            hasChildren: false,
                            parentId:itemId
                        }]
                    }
                    let group = this.replaceGroupItemsInModel('reportSections', 'Edit Reports', groupType, nodes);
                    if($.isEmptyObject(group)){
                        group = {
                            nodes:nodes
                        }
                    }
                    this.addItemsToGroup(group, dataTarget);
                    this.selectedNodeOnTree = group.id;
                    this.selectedNodeTarget = dataTarget;
                    ev.stopPropagation();
                }, (error) => {
                    console.log(error);

                    let msg = error || 'getReportsByGroupType rejected due to unknown Error';
                    NotificationService.error(msg);
                    ev.stopPropagation();

                }).catch((error) => {
                    console.log(error);

                    let msg = error || 'Unknown Error';
                    NotificationService.error(msg);
                    ev.stopPropagation();
                })
            };
            // Just for View Reports.
            const _viewReports = () => {
                let dataTarget = ev.currentTarget.attributes['data-target'].value;
                itemId = itemId !== constants.REPORTS_VIEW_GROUP_TYPE ? itemId : constants.DEFAULT_GROUP_ID;

                RestService.getPublishedReports(itemId).then((data) => {
                    let reports = data.RESULT.RESPONSE.Group;

                    let nodes = [];
                    if (reports) {
                        nodes = this.loadNodesFromResponse(reports, groupType,itemId);
                    } else {
                        nodes = [{
                            nodeName: 'no items',
                            url: '#',
                            icon: ICON_EMPTY,
                            id: 0,
                            groupType: groupType,
                            nodeType: '',
                            hasChildren: false,
                            parentId:itemId
                        }]
                    }
                    // As no default folders are present in this report treeview, its required to add the first nodes directly after the View Forms Section.
                    if(itemId===constants.DEFAULT_GROUP_ID){
                        let viewFormsSectionModel=this.model.get('reportSections').sections[1];
                         nodes.forEach((node)=>{
                             if(node.hasChildren){
                                 viewFormsSectionModel.groups.push(node);
                             }
                             else{
                                 viewFormsSectionModel.nodes.push(node);
                             }
                         });

                        if (ev.currentTarget.children.length > 1) {
                            dataTarget = ev.currentTarget.children[1].attributes['data-target'].value;
                        }
                        else{
                            dataTarget = ev.currentTarget.attributes['data-target'].value;
                        }
                        var group={
                            nodes:nodes
                        };
                        this.addItemsToSection(group, dataTarget);
                        this.selectedNodeOnTree = group.id;
                        this.selectedNodeTarget = dataTarget;
                    }
                    else{
                        let group = this.replaceGroupItemsInModel('reportSections', 'View Reports', itemId, nodes);
                        this.addItemsToGroup(group, dataTarget);
                        this.selectedNodeOnTree = group.id;
                        this.selectedNodeTarget = dataTarget;
                    }
                    ev.stopPropagation();
                    this.handleSection(ev);
                 }).catch((error) => {
                    console.log(error);
                    var msg = error || 'Unknown Error';
                    NotificationService.error(msg);
                })
            };

            const map = {'attn': _none, 'editReports': _none, 'group': _group, 'viewReports': _viewReports, 'none': _none};

            if (map[nodeType]) {
                (map[nodeType])();
                listService.avoidDoubleClickOnDashboardTree = false;
            }
        }
        else {
           listService.avoidDoubleClickOnDashboardTree = false;
           this.handleSection(ev);
        }

        if (nodeType !== 'attn') {
            this.collapseWithoutPropagation(ev);
        }
    }

    checkForEnablingViewReportsMenu(eventTarget){
        let targetToWork = eventTarget;
        if(eventTarget.is('h4')){
            targetToWork = eventTarget.find('a');
        }
        // else if(eventTarget.is('i')){
        //     targetToWork = eventTarget.parent();
        // }
        let currentSection = targetToWork.data('nodetype');
        let groupType = String(targetToWork.data('grouptype'));
        if(currentSection === 'viewReports'){
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().removeClass('li-disabled');
            $("#createPersonalFolder").parent().removeClass('li-disabled');
        }
        else if(currentSection === 'viewReports' && targetToWork.text().includes('View Reports')){
            $(".user-list-private").removeClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().removeClass('li-disabled');
            $("#createPersonalFolder").parent().removeClass('li-disabled');
        }
        else{
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $(".user-list-private").removeClass('hide');
            $(".user-list-view").addClass('hide');
        }
        if(groupType === constants.ACCOUNT_FOLDER_REPORT_GROUP_TYPE ){
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().removeClass('li-disabled');
            $("#createPersonalFolder").parent().addClass('li-disabled');
        }
        else if(groupType === constants.PERSONAL_FOLDER_REPORT_GROUP_TYPE ){
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().addClass('li-disabled');
            $("#createPersonalFolder").parent().removeClass('li-disabled');
        }
    }



    renderReportsDashboard(ev, type){
        this.killDetailView();

        // API Call to /Reports/Dashboard
        let editRequestParamsObject={
            includeRecentManagedReports:'true',
            includeFavoriteReports: 'true',
            includeRecentPlayedReports: 'true'
        };

        RestService.getDashboardDetails(editRequestParamsObject).then((data) => {
            let reportsList = [];
            let currentFavoritesList = [];
            let recentPlayedList = [];
            let formatResult = (result, field) => {
                return result[field] instanceof Array ? result[field]: [result[field]];
            };

            const recentManaged = data.RESULT.RESPONSE.recentManagedReports;
            if (recentManaged && recentManaged.report) {
                reportsList = formatResult(recentManaged, 'report');
            }

            const recentPlayed = data.RESULT.RESPONSE.recentPlayedReports;
            if (recentPlayed && recentPlayed.report) {
                recentPlayedList = formatResult(recentPlayed, 'report');
            }

            const favoriteReports = data.RESULT.RESPONSE.favoriteReports;
            if (favoriteReports && favoriteReports.report) {
                currentFavoritesList = formatResult(favoriteReports, 'report');
            }

            RestService.getReportsByGroupType(constants.REPORTS_PRIVATE_GROUP_TYPE).then((data)=> {
                let pReports = [];
                const privateReports = data.RESULT.RESPONSE;
                if (privateReports && privateReports.Group && privateReports.Group.Item) {
                    pReports = formatResult(privateReports.Group, 'Item');
                }

                const reportDetailsModel = new ReportDetailsModel();
                reportDetailsModel.set('reports', type === 'edit' ? reportsList : recentPlayedList);
                reportDetailsModel.set('privateReports', pReports);
                reportDetailsModel.set('currentFavoritesList', currentFavoritesList, {silent: true});

                let newDetailView = type === 'edit' ? new EditReportsDashboardView({model: reportDetailsModel, el: constants.DASHBOARD_MAIN_PANEL})
                    : new ViewReportsDashboardView({model: reportDetailsModel, el: constants.DASHBOARD_MAIN_PANEL});

                let mainPanelView = listService.dashboardLayout.mainPanelView;

                if (mainPanelView) {
                    mainPanelView.undelegateEvents();
                    mainPanelView.off();
                }

                let titleSection = type === 'edit' ? 'Edit Recent' : 'View Recent';
                reportDetailsModel.set('titleSection', titleSection);
                reportDetailsModel.set('type', type);

                listService.dashboardLayout.mainPanelView = newDetailView;

                this.detailView = newDetailView;
                this.detailView.render();    
            });

            ev && ev.stopPropagation();
         }).catch((err)=>{
            console.log("An error has ocurred",err);
            ev && ev.stopPropagation();
        });
    }

    // Override Base for Specific Handling
    handleSection(ev) {
        const sectionType = ev.currentTarget.attributes['data-nodeType'].value;


        if (ev) {
            super.handleSection(ev);
        }

        if(!this.model.get('isNew')){
            const _none = () => {
                ev.stopPropagation();
            };

            const _editReportsDashboard = () => {
                this.renderReportsDashboard(ev,'edit');
            };

            const _viewReportsDashboard = () => {
                this.renderReportsDashboard(ev,'view');
            };


            const map = {'none': _editReportsDashboard, 'editReports': _editReportsDashboard,'viewReports': _viewReportsDashboard};
            if (map[sectionType]) {
                (map[sectionType])();
            }
        }
        this.model.set('isNew',false,{silent:true})
    }

    handleSelectedGroup(ev) {
        let eventTarget = $(ev.target);
        let isForWithNoChildren = eventTarget.attr('data-nodetype') === 'attn' && eventTarget.attr('data-haschildren') === 'false';

        if (isForWithNoChildren) {
            return;
        }

        if (listService.avoidDoubleClickOnDashboardTree) {
            return;
        }

        listService.avoidDoubleClickOnDashboardTree = true;

        const itemSelected = $(ev.currentTarget).parent().find('.bg-success');
         if (itemSelected.length > 0){
             listService.reportItemSelected = undefined;
         }

        const sectionType = ev.currentTarget.attributes['data-nodeType'].value;
        const id = ev.currentTarget.attributes['data-groupid'].value;
        

        if (!$(ev.target).parent().is('a')) {
            this.removeItemGroupSelection();
            $(ev.currentTarget).addClass('bg-success');
        }

        if (util.isTrue(userService.checkPermissions('folders'))){
            $('#createFolder').parent('li').removeClass('li-disabled');
        }else{
            $('#createFolder').parent('li').addClass('li-disabled');
        }

        this.isPrivateSectionSelected = sectionType === constants.REPORTS_PRIVATE_SECTION;

        if (sectionType === constants.REPORTS_PRIVATE_SECTION || sectionType === constants.REPORTS_SHARED_SECTION) {
            const groupTypeId = id;
            const dataTarget = ev.currentTarget.children[1].attributes['data-target'].value;

            const icon = $('a[data-target="' + dataTarget + '"] i');
            const target = $(ev.currentTarget).find('.switch');

            util.togglePanel(target, icon);

            // if classname of children[1] contains 'collapsed' then ignore , only load on expand.
            if (new RegExp('collapsed').test(ev.currentTarget.children[1].className)) {

                RestService.getReportsByGroupType(groupTypeId).then( data => {
                    const reports = data.RESULT.RESPONSE.Group;
                    if (reports) {
                        const nodes = this.loadNodesFromResponse(reports, groupTypeId);

                        // Update Model So It Will Be There Later, duh.
                        const group = this.replaceGroupItemsInModel('reportSections', 'Edit Reports', groupTypeId, nodes);
                        this.addItemsToGroup(group, dataTarget);
                        this.selectedNodeOnTree = group.id;
                        this.selectedNodeTarget = dataTarget;
                        this.selectedGroupType = groupTypeId;
                        this.selectedGroupParentId = constants.DEFAULT_GROUP_ID;
                        this.selectedNodeType = sectionType;
                        this.selectedNodeParentId = constants.DEFAULT_GROUP_ID;
                    }

                    listService.avoidDoubleClickOnDashboardTree = false;

                }, error => {
                    console.log(error);
                    var code = error.CODE || error;
                    NotificationService.error(restMessages.codeToMessage(code));
                }).catch( error => {
                    console.log(error);
                    var msg = error || 'Unknown Error';
                    NotificationService.error(msg);
                });
            }else{
                this.selectedNodeOnTree = undefined;
                this.selectedNodeTarget = undefined;
                this.selectedGroupType = id;
                this.selectedNodeType = sectionType;
                this.selectedNodeParentId = constants.DEFAULT_GROUP_ID;
                this.selectedGroupParentId = constants.DEFAULT_GROUP_ID;
                listService.avoidDoubleClickOnDashboardTree = false;
            }

            this.activateSection(ev);
        }
    }

    handleSelectedGroupItem(ev) {
        let eventTarget = $(ev.target);
        let itemId = eventTarget.data('itemid');
        let currentSection = eventTarget.data('nodetype');
        let groupType = eventTarget.data('grouptype');
        if (currentSection === 'viewReports') {
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").removeClass('li-disabled');
            $("#createPersonalFolder").removeClass('li-disabled');
        }
        else {
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $(".user-list-private").removeClass('hide');
            $(".user-list-view").addClass('hide');

            $(`i[data-itemid="${eventTarget[0].dataset.itemid}"]`).click();
        }
        if (groupType === constants.ACCOUNT_FOLDER_REPORT_GROUP_TYPE) {
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().removeClass('li-disabled');
            $("#createPersonalFolder").parent().addClass('li-disabled');
        }
        else if (groupType === constants.PERSONAL_FOLDER_REPORT_GROUP_TYPE) {
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().addClass('li-disabled');
            $("#createPersonalFolder").parent().removeClass('li-disabled');
        }

        const refreshButton = $('#pf-refresh-main-view'); //reset id in refresh button
        refreshButton.attr("data-appid", itemId.split("_")[1]);    


        let spinner = $(".spinner").is(":visible");
        if (ev.type === 'click' && (!spinner) ) {

            try {
                ev.preventDefault();
            } catch (e) {
                console.log("error", e);
            }

            if (this.detailView) {
                const applyChangesElement = $('#applyChangesReport'),
                        confirmationText = 'Are you sure you want to leave this page?<br /><br />All changes made to the current page will be lost.',
                        subtitle = `Report - ${this.detailView.model.get('reportName')}`;

                util.showConfirmationDashboardChangesModal(applyChangesElement, this.openGroupDetailView, confirmationText, subtitle, ev,this);
            }
            else {
                this.openGroupDetailView(ev)
            }

            this.activateSection(ev);
        }
    }

    handleDblSelectedGroupItem(ev) {

        const target = $(ev.currentTarget);
        const nodeType = target.attr('data-nodetype');
        const groupType = target.attr('data-grouptype');
        const innerText = target.text();
        //Main folders in Shared
        const isUser = target.attr('data-isuser') === 'user' || target.attr('data-isuser') === 'otheruser';

        if (groupType === 'viewReports' || isUser) {
            return;
        }

        if (ev.type === 'dblclick' && nodeType!=='' && innerText !== '' || isUser) {
            try {
                ev.preventDefault();
            } catch (e) {
                console.log("error", e);
            }

            localStorage.setItem('oriVal', innerText);
            target.text('');
            $(util.inputRenameTree(innerText)).appendTo(target).trigger("focus").trigger("select");
        }
        ev.stopPropagation();
        return false;
    }

    handleFocusOut(ev){
        var $this = $(ev.currentTarget);
        var parent=$this.parent();
        let groupId=parent.attr('data-itemid');
        let reportId=parent.attr('data-itemid').split('_')[1] || parent.attr('data-itemid');
        let groupType=parent.attr('data-grouptype');
        let originalValue = localStorage.getItem('oriVal').trim();
        let reportName = $this.val().trim() || originalValue;
        $this.parent().text(reportName);
        const nodeType = parent.data('nodetype');
        let id = nodeType === 'group' ? reportId : groupType + "_" + reportId;
        let link = $('a[data-itemid="'+ id +'"]');
        link.prop('title', reportName);

        if($this.val().trim() !== originalValue) {
            let reportName=$this.val().trim() || originalValue;
            const nodeType = parent.data('nodetype');
            $this.parent().text(reportName);

            const updateResponse = (msg, status) => {
                if (status === 'success') {
                    NotificationService.success(msg);
                } else {
                    NotificationService.error(msg);
                }
                $('#dashboard-left-panel .item-link').prop('disabled', false);
            }

            if($('#dashboard-left-panel .item-link').is(':disabled')===false) {
                if (nodeType === 'group') {
                    $('#dashboard-left-panel .item-link').prop('disabled', true);
                    RestService.renameFolder({idFolder:reportId, newName:reportName, isForm:false}).then(data => {
                        updateResponse(data.msg, 'success');
                    },  err => {
                        updateResponse(data.msg, 'error');
                    });
                    undoService.add({
                        undo:() => {
                            RestService.renameFolder({idFolder:reportId, newName:reportName, isForm:false}).then(data => {
                                    $(`a[title="${reportName}"]`).text(originalValue).prop('title', originalValue);
                                    updateResponse(data.msg, 'success');
                                },
                                err => {
                                    updateResponse(data.msg, 'error');
                                });
                        },
                        redo:() => {
                            RestService.renameFolder({idFolder:reportId, newName:reportName, isForm:false}).then(data => {
                                    $(`a[title="${originalValue}"]`).text(reportName).prop('title', reportName);
                                    updateResponse(data.msg, 'success');
                                },
                                err => {
                                    updateResponse(data.msg, 'error');
                                });
                        }
                    },textConstants.UNDO_RENAME_FOLDER);


                } else {
                    RestService.updateReportName(reportId, reportName).then(data => {
                        updateResponse('Report succesfuly renamed.', 'success');
                        eventBus.trigger(constants.EV_UPDATE_REPORT_DETAILS, reportId, groupType, groupId);
                    },  err => {
                        updateResponse(data.msg, 'error');
                    });
                    undoService.add({
                        undo:() => {
                            RestService.updateReportName(reportId, originalValue).then(data => {
                                let anchorToUpdate = $(`a[title="${reportName}"]`);
                                anchorToUpdate.text(originalValue);
                                anchorToUpdate.prop('title', originalValue);
                                updateResponse('Report succesfuly restored.', 'success');
                                eventBus.trigger(constants.EV_UPDATE_REPORT_DETAILS, reportId, groupType, groupId);
                            }, err => {
                                updateResponse(data.msg, 'error');
                            });
                        },
                        redo:() => {
                            RestService.updateReportName(reportId, reportName).then(data => {
                                let anchorToUpdate = $(`a[title="${originalValue}"]`);
                                anchorToUpdate.text(reportName);
                                anchorToUpdate.prop('title', reportName);
                                updateResponse('Report succesfuly renamed.', 'success');
                                eventBus.trigger(constants.EV_UPDATE_REPORT_DETAILS, reportId, groupType, groupId);
                            }, err => {
                                updateResponse(data.msg, 'error');
                            });
                        }
                    },textConstants.UNDO_RENAME_REPORT);
                }
            }


        }

        $this.remove();
    }

    handleEnter(ev){
        var code = ev.keyCode || ev.which;
        if (code === 13) {
            ev.preventDefault();
            $(ev.currentTarget).blur();
        }
    }

    openGroupDetailView(ev){
        var itemId = ev.currentTarget.attributes['data-itemid'].value;
        var groupType = ev.currentTarget.attributes['data-groupType'].value;
        var nodeType = ev.currentTarget.attributes['data-nodeType'].value;
        var parentId = ev.currentTarget.attributes['data-parentId'].value;
        let formTreeData=$(ev.currentTarget).siblings('i');

        if (nodeType !== 'group'){
            if (!$('#createFolder').parent('li').hasClass('li-disabled')) {
                $('#createFolder').parent('li').addClass('li-disabled');
            }
        }else{
            parentId = parentId ? parentId : itemId;
            if ($('#createFolder').parent('li').hasClass('li-disabled')) {
                $('#createFolder').parent('li').removeClass('li-disabled');
            }
        }

        // This check is performed when an item is selected on the tree that is not a folder.
        if($(ev.currentTarget).siblings('span').hasClass( constants.DB_ICON_EMPTY )){
            let parent = $(ev.currentTarget).parents('div')[0];
            this.selectedNodeOnTree =  $(parent).attr('id').includes('_') ? $(parent).attr('id').substring(5) : $(parent).attr('id').substring(4);
            this.selectedNodeTarget = '#'+$(parent).attr('id');
            this.selectedNodeParentId = parentId;
        }
        else {
            let formTreeDataItemId = $(formTreeData).attr('data-itemid');
            this.selectedNodeOnTree = formTreeDataItemId.indexOf('_') > 0
                ? formTreeDataItemId.substring(2)
                : formTreeDataItemId;
            this.selectedNodeTarget = $(formTreeData).attr('data-target');
            this.selectedNodeParentId= parentId;
        }

        this.selectedGroupType =  groupType;
        this.selectedNodeType =  nodeType;
        this.selectedGroupParentId = this.selectedNodeOnTree;

        var otherData = ev.currentTarget.attributes['data-other'] ? ev.currentTarget.attributes['data-other'].value : '';
        var formName = $(ev.currentTarget).text();

        this.removeItemGroupSelection();

        if ($(ev.target).parents('#well_4').length > 0 || $(ev.target).parents('#well_5').length > 0) {
            this.handleExpand(ev);
        }

        this.addItemGroupSelection(ev.currentTarget);

        const _attn = () => {
            this.killDetailView();

            let reportIdSubstring = itemId.split('_');
            let reportLength = reportIdSubstring.length;
            let reportId=reportIdSubstring[reportLength - 1];
            this.renderReportDetails(reportId, groupType, itemId,parentId);

        };

        const map = {
            'attn': _attn
        };

        if (nodeType === 'group') {
            listService.reportItemSelected = {
                reportName: formName,
                reportId: itemId,
                reportLink: '',
                versionList: '',
                groupType: groupType,
                nodeType: nodeType
            };
        }

        const fn = map[nodeType];
        if (fn) {
            (fn)();
        }
    }

    shareReport(reportId, groupType, itemId, groupId, name) {
        let isAddedOnRoot = groupId === constants.DEFAULT_GROUP_ID;
        let nodeTarget = isAddedOnRoot ? '#well_3 >' :`#well${groupId}`;
        this.selectedNodeTarget = undefined;
        const $element = $(`a[data-itemid$='${reportId}']`).parent();

        if ($element.length) {
            $element.remove();
        }

        this.notifyNewReport({reportId,name,groupTypeId:groupType,parentId:groupId,nodeTarget},false);
    }

    unShareReport(reportId, groupType, itemId, groupId, name) {
        let isAddedOnRoot = groupId === constants.DEFAULT_GROUP_ID;
        let nodeTarget = isAddedOnRoot ? '#well_2 >' :`#well${groupId}`;
        this.selectedNodeTarget = undefined;
        const $element = $(`a[data-itemid$='${reportId}']`).parent();
        if ($element.length) {
            $element.remove();
        }

        this.notifyNewReport({reportId,name,groupTypeId:groupType,parentId:groupId,nodeTarget},false);
    }

    renderReportDetails(reportId, groupType, itemId, parentId, isPrivate) {
        this.renderReportDetailsDebounced(reportId, groupType || constants.FORMS_VIEW_GROUP_TYPE, itemId || `${constants.FORMS_VIEW_GROUP_TYPE}_${reportId}`, parentId, isPrivate);
    }

    loadNodesFromResponse(reports, groupType,itemId) {
        let nodes = [];
        let itemNodeType = '';
        let groupResponseType='';

        if (groupType === constants.REPORTS_PRIVATE_GROUP_TYPE ||
            groupType === constants.REPORTS_SHARED_GROUP_TYPE ){
            itemNodeType = 'group';
            groupResponseType=groupType;
        }
        else {
            itemNodeType = 'viewReports';
            groupResponseType=itemNodeType;
        }

        // Need to handle Folders
        if (reports.Group) {

            // Folders always call /Report/Browse or /Report/BrowseViewable if they are Published Reports.
            // Checking whether is an Array or an object so we can loop the items
            // or access the single object properties
            if (reports.Group instanceof Array) {


                for (let group of reports.Group) {

                    let iconFolder = ICON_FOLDER;
                    if(group['@type'] === constants.ACCOUNT_FOLDER_REPORT_GROUP_TYPE || groupType === constants.ACCOUNT_FOLDER_REPORT_GROUP_TYPE ){
                        iconFolder = ICON_FOLDER_ACCOUNT;
                    }
                    let fixedGroupType = group['@type'] || groupType;
                    if (group['@type']=== 'normal' || group['@type']=== 'user' || group['@type']=== 'otheruser' ){
                        fixedGroupType = groupType;
                    }

                    nodes.push(
                        {
                            nodeName: group['@name'],
                            icon: iconFolder,
                            nodes: [],
                            id: group['@groupId'] || group['@id'],
                            groupType: fixedGroupType ,
                            nodeType: itemNodeType,
                            toggleIcon: 'pf-carot-left',
                            hasChildren: true,
                            isUserType: group['@type'],
                            parentId: itemId
                        });
                }
            }
            else {
                let iconFolder = ICON_FOLDER;
                if(reports.Group['@type'] === constants.ACCOUNT_FOLDER_REPORT_GROUP_TYPE ||
                    groupType === constants.ACCOUNT_FOLDER_REPORT_GROUP_TYPE ){
                    iconFolder = ICON_FOLDER_ACCOUNT;
                }
                let fixedGroupType = reports.Group['@type'] || groupType;
                if (reports.Group['@type']=== 'normal' || reports.Group['@type']=== 'user' || reports.Group['@type']=== 'otheruser' ){
                    fixedGroupType = groupType;
                }

                nodes.push(
                    {
                        nodeName: reports.Group['@name'],
                        icon: iconFolder,
                        nodes: [],
                        id: reports.Group['@groupId'] || reports.Group['@id'],
                        groupType:  fixedGroupType,
                        nodeType: itemNodeType,
                        toggleIcon: 'pf-carot-left',
                        hasChildren: true,
                        isUserType: reports.Group['@type'],
                        parentId: itemId
                    });
            }


        }

        // This will do Items. Not only the item will be an array.
        if (reports.Item) {
            if (reports.Item instanceof Array) {
                _.forEach(reports.Item, function (d) {
                    var hasChildren = false;
                    nodes.push({
                        nodeName: d['@name'],
                        url: '#',
                        icon: ICON_EMPTY,
                        id: groupType + '_' + d['@id'],
                        groupType: d['@type'] || groupType,
                        nodeType: 'attn',
                        hasChildren: hasChildren,
                        toggleIcon: hasChildren ? 'pf-carot-left' : '',
                        parentId:itemId
                    });
                });
            }
            else {
                nodes.push({
                    nodeName: reports.Item['@name'],
                    url: '#',
                    icon: ICON_EMPTY,
                    id: groupType + '_' + reports.Item['@id'],
                    groupType: reports.Item['@type'] || groupType,
                    nodeType: 'attn',
                    hasChildren: false,
                    toggleIcon: '',
                    parentId:itemId
                });
            }
        }

        return nodes;
    }

    createFolder(ev){
         switch(this.selectedGroupType){
            case constants.REPORTS_PRIVATE_GROUP_TYPE:
            case constants.REPORTS_SHARED_GROUP_TYPE:
                this.processAddReportFolder();
                break;
            case 'viewReports':
            case constants.ACCOUNT_FOLDER_REPORT_GROUP_TYPE :
            case constants.PERSONAL_FOLDER_REPORT_GROUP_TYPE :
            case constants.REPORTS_VIEW_GROUP_TYPE :
                 this.processAddPrivateOrAccountFolder(ev);
                 break;
        }
    }

    processAddPrivateOrAccountFolder(ev){
        let folderTypeChosen=$(ev.currentTarget).data('group-type');
        console.log("Folder Type Chosen",folderTypeChosen);
        let folderParent=$(".bg-success > a").data('parentid') === constants.DEFAULT_GROUP_ID ?
            $(".bg-success > a").data('itemid') :
            $(".bg-success > a").data('parentid');
        let isAddedOnRoot;
        if(util.isEmpty(folderParent)){
            folderParent = constants.DEFAULT_GROUP_ID;
            isAddedOnRoot = true;
        }
        else{
            isAddedOnRoot = false;
        }

        reportFolderService.newReportFolder({ name: constants.DEFAULT_FORM_FOLDER_NAME, groupTypeId: folderTypeChosen, groupParentId: folderParent, isAddedOnRoot: isAddedOnRoot}).then((result) => {
            let iconFolder = ICON_FOLDER;
            if(String(folderTypeChosen) === constants.ACCOUNT_FOLDER_REPORT_GROUP_TYPE ){
                iconFolder = ICON_FOLDER_ACCOUNT;
            }

            NotificationService.success(result.msg);
            let targetToAddItem = isAddedOnRoot ? $(constants.VIEW_FORMS_CONTAINER + ' UL') : $(`#well${folderParent} UL`);

            const newNode = {
                node: {
                    nodeName: result.name,
                    icon: iconFolder,
                    nodes: [],
                    id: result.reportFolderId,
                    groupType: folderTypeChosen,
                    nodeType: 'group',
                    hasChildren: false,
                    parentId:  result.reportFolderId,
                    toggleIcon: 'pf-carot-left',
                    selected:true
                }
            };

            // clear other selections
            $('li[role="button"]').removeClass('bg-success');


            if ($(targetToAddItem.children()[0]).text().trim() === 'no items') {
                $(targetToAddItem.children()[0]).remove();
            }

            // PF-3982: Fix for new folders on root level
            newNode.node.parentId = newNode.node.parentId || newNode.node.id;

            $(targetToAddItem[0]).append(singleItemTemplate(newNode));

            // PF-4679 Adding Right Click and Drag Drop to this area?
            // setTimeout(()=>{
            //     super.makeDroppables( this.expandUpdatedListOfPrivateNodes );
            //     super.attachRightClickMenu();
            // },0);
        }, (errMsg) => {
            NotificationService.error(errMsg);
        });
    }

    processAddReportFolder() {
        let isAddedOnRoot = constants.DEFAULT_GROUP_ID === this.selectedGroupParentId;

        // API Call to Form/Add
        let _groupParentId = this.selectedNodeParentId;
        if (typeof _groupParentId === 'undefined'){
            _groupParentId = this.selectedGroupParentId;
        }

        reportFolderService.newReportFolder({ name: constants.DEFAULT_FORM_FOLDER_NAME, groupTypeId: this.selectedGroupType, groupParentId: _groupParentId, selectedNodeTarget:this.selectedNodeTarget,isAddedOnRoot:isAddedOnRoot}).then((result) => {
            NotificationService.success(result.msg);

            // Process Closed and Form Instances
            // Render Either View or Edit Form
            let targetToAddItem = $(this.selectedNodeTarget + ' UL');

            if ( isAddedOnRoot ){
                targetToAddItem = String(this.selectedGroupType) === constants.REPORTS_PRIVATE_GROUP_TYPE
                    ? $(constants.EDIT_FORMS_CONTAINER + ' UL')
                    : $(constants.SHARED_FORMS_CONTAINER + ' UL') ;
            }
            const newNode = {
                node: {
                    nodeName: result.name,
                    icon: ICON_FOLDER,
                    nodes: [],
                    id: result.reportFolderId,
                    groupType: this.selectedGroupType,
                    nodeType: 'group',
                    hasChildren: false,
                    parentId: result.reportFolderId,
                    toggleIcon: 'pf-carot-left'
                }
            };

            // PF-3982: Fix for new folders on root level
            newNode.node.parentId = newNode.node.parentId || newNode.node.id;

            // clear other selections
            $('li[role="button"]').removeClass('bg-success');
            if ($(targetToAddItem.children()[0]).text().trim() === 'no items') {
                $(targetToAddItem.children()[0]).remove();
            }
            $(targetToAddItem[0]).append(singleItemTemplate(newNode));
            setTimeout(()=>{
                super.makeDroppables( this.processAddReportFolder );
                if ( !$(`#well${_groupParentId}`).hasClass('in') ) {
                    $(`i[data-target="#well${_groupParentId}"]`).trigger('click');
                }
            },0);
        }, (errMsg) => {
            NotificationService.error(errMsg);
        });
    }

   undeletedReportFolder(selectedGroupType,groupParentId,selectedNodeTarget,isAddedOnRoot,result){
    let targetToAddItem = $(selectedNodeTarget + ' UL');

    if ( isAddedOnRoot ){
        targetToAddItem = String(selectedGroupType) === constants.REPORTS_PRIVATE_GROUP_TYPE
            ? $(constants.EDIT_FORMS_CONTAINER + ' UL')
            : $(constants.SHARED_FORMS_CONTAINER + ' UL') ;
    }
    const newNode = {
        node: {
            nodeName: result.name,
            icon: ICON_FOLDER,
            nodes: [],
            id: result.reportFolderId,
            groupType: selectedGroupType,
            nodeType: 'group',
            hasChildren: false,
            parentId: result.reportFolderId,
            toggleIcon: 'pf-carot-left'
        }
    };

    // PF-3982: Fix for new folders on root level
    newNode.node.parentId = newNode.node.parentId || newNode.node.id;

    // clear other selections
    $('li[role="button"]').removeClass('bg-success');
    if ($(targetToAddItem.children()[0]).text().trim() === 'no items') {
        $(targetToAddItem.children()[0]).remove();
    }
    $(targetToAddItem[0]).append(singleItemTemplate(newNode));
    setTimeout(()=>{
        super.makeDroppables( this.processAddReportFolder );
        if ( !$(`#well${groupParentId}`).hasClass('in') ) {
            $(`i[data-target="#well${groupParentId}"]`).trigger('click');
        }
    },0);
   }

    import() {
        let model = new Model({width: 475, height: 'auto'});
        var importModal = new ImportModal({ model: model, el:content });

        importModal.selectedImport = 'report';
        importModal.render();
    }

    loadPrivateOrSharedReports(groupTypeId,dataTarget,sectionType){
        util.disableReloadLink();
        util.cleanChildNodes(dataTarget);
        RestService.getReportsByGroupType(groupTypeId).then( data => {
            util.enableReloadLink();
            const reports = data.RESULT.RESPONSE.Group;
            if (reports) {
                const nodes = this.loadNodesFromResponse(reports, groupTypeId);
                // Update Model So It Will Be There Later, duh.
                const group = this.replaceGroupItemsInModel('reportSections', 'Edit Reports', groupTypeId, nodes);
                this.addItemsToGroup(group, dataTarget);
                this.selectedNodeOnTree = group.id;
                this.selectedNodeTarget = dataTarget;
                this.selectedGroupType = groupTypeId;
                this.selectedGroupParentId = constants.DEFAULT_GROUP_ID;
                this.selectedNodeType = sectionType;
            }
        }, error => {
            console.log(error);
            var code = error.CODE || error;
            NotificationService.error(restMessages.codeToMessage(code));
        }).catch( error => {
            util.enableReloadLink();
            console.log(error);
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    renderEditReportFolderNodes(groupId,groupTypeId,nodeType,dataTarget){
        util.cleanChildNodes(dataTarget);
        util.disableReloadLink();
        RestService.getReportsByGroupType(groupTypeId, groupId).then((data) => {
            util.enableReloadLink();
            let reports = data.RESULT.RESPONSE.Group;

            let nodes = [];
            if (reports) {
                nodes = this.loadNodesFromResponse(reports, groupTypeId);
            } else {
                nodes = [{
                    nodeName: 'no items',
                    url: '#',
                    icon: ICON_EMPTY,
                    id: 0,
                    groupType: groupTypeId,
                    nodeType: '',
                    hasChildren: false
                }]
            }
            let group = this.replaceGroupItemsInModel('reportSections', 'Edit Reports', groupId, nodes);

            this.addItemsToGroup(group, dataTarget);
            this.selectedNodeOnTree = group.id;
            this.selectedNodeTarget = dataTarget;
        }).catch((error) => {
            console.log(error);
            util.enableReloadLink();
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    renderViewReportNodes(groupTypeId,nodeType,groupType,dataTarget){
        util.disableReloadLink();
        util.cleanChildNodes(dataTarget);
        $('a[data-target="'+ dataTarget + '"] i').toggleClass('pf-carot-left pf-carot-down');
        RestService.getPublishedReports().then((data) => {
            util.enableReloadLink();
            let reports = data.RESULT.RESPONSE.Group;
            var nodes = [];
            if (reports) {
                nodes = this.loadNodesFromResponse(reports, groupTypeId);
            } else {
                nodes = [{
                    nodeName: 'no items',
                    url: '#',
                    icon: ICON_EMPTY,
                    id: 0,
                    groupType: groupType,
                    nodeType: '',
                    parentId: null,
                    hasChildren: false
                }]
            }

            let group = {
                nodes: nodes
            }


            this.addItemsToSection(group, dataTarget);
            this.selectedNodeOnTree = group.id;
            this.selectedNodeTarget = dataTarget;
            this.selectedGroupType = groupType;
            this.selectedNodeType=nodeType;
        }).catch((error) => {
            console.log(error);
            util.enableReloadLink();
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    renderViewReportFolderNodes(groupTypeId,nodeType,groupType,dataTarget){
        util.disableReloadLink();
        util.cleanChildNodes(dataTarget);
        $('a[data-target="'+ dataTarget + '"] i').toggleClass('pf-carot-left pf-carot-down');

        RestService.getPublishedReports(groupTypeId).then((data) => {
            util.enableReloadLink();
            let reports = data.RESULT.RESPONSE.Group;
            let nodes = [];
            if (reports) {
                nodes = this.loadNodesFromResponse(reports, groupType);
            } else {
                nodes = [{
                    nodeName: 'no items',
                    url: '#',
                    icon: ICON_EMPTY,
                    id: 0,
                    groupType: groupType,
                    nodeType: '',
                    hasChildren: false
                }]
            }

                let group = this.replaceGroupItemsInModel('reportSections', 'View Reports', groupTypeId, nodes);
                this.addItemsToGroup(group, dataTarget);
                this.selectedNodeOnTree = group.id;
                this.selectedNodeTarget = dataTarget;
        }).catch((error) => {
            console.log(error);
            util.enableReloadLink();
            let msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    refreshReportsMainView(refreshTree){
        let editRequestParamsObject = {
            includeRecentManagedReports: 'true',
            includeFavoriteReports: 'true'
        };

        RestService.getDashboardDetails(editRequestParamsObject).then((data)=> {
            let reports = [];
            let currentFavoritesList = [];

            const recentManagedReports = data.RESULT.RESPONSE.recentManagedReports;
            const favoriteReports = data.RESULT.RESPONSE.favoriteReports;

            if (recentManagedReports && recentManagedReports.report) {
                reports = data.RESULT.RESPONSE.recentManagedReports.report instanceof Array
                    ? data.RESULT.RESPONSE.recentManagedReports.report
                    : [data.RESULT.RESPONSE.recentManagedReports.report];
            }

            if (favoriteReports && favoriteReports.report) {
                currentFavoritesList = favoriteReports.report instanceof Array
                    ? favoriteReports.report
                    : [favoriteReports.report];
            }

            RestService.getReportsByGroupType(constants.REPORTS_PRIVATE_GROUP_TYPE).then((data)=> {

                RestService.setToken(data.RESULT.TOKEN);

                let pReports = [];
                const privateReports = data.RESULT.RESPONSE.Group;
                if (privateReports && privateReports.Item) {
                    pReports = data.RESULT.RESPONSE.Group.Item instanceof Array
                        ? data.RESULT.RESPONSE.Group.Item
                        : [data.RESULT.RESPONSE.Group.Item];
                }
                const reportDetailsModel = new ReportDetailsModel();
                reportDetailsModel.set('reports', reports);
                reportDetailsModel.set('privateReports', pReports);
                reportDetailsModel.set('currentFavoritesList', currentFavoritesList);

                let reportMainViewDetails=new ViewReportsDashboardView({model: reportDetailsModel, el: constants.DASHBOARD_MAIN_PANEL});
                listService.dashboardLayout.mainPanelView=reportMainViewDetails;
                this.detailView = reportMainViewDetails;
                this.detailView.render();

                if(refreshTree){
                    if (listService.dashboardLayout.leftPanelView.isPrivateSectionSelected) {
                        setTimeout(function() {
                          eventBus.trigger(constants.EV_REFRESH_PRIVATE_REPORT_NODES,
                                           constants.REPORTS_PRIVATE_GROUP_TYPE,
                                           constants.EDIT_FORMS_CONTAINER, 
                                           constants.REPORTS_PRIVATE_SECTION);
                        }, 10);
                    }
                }

            }).catch((error) => {
                console.log(error);
                var msg = error || 'Error on Retrieving Reports By Group Type';
                NotificationService.error(msg);
            });

        }).catch((error) => {
            console.log(error);
            var msg = error || 'Error on Retrieving Reports Dashboard Data';
            NotificationService.error(msg);
        });
    }

    processDeleteReport(elm) {
        const reportIdData = elm.itemid.split('_'),
            reportId = reportIdData.length === 1 ? elm.itemid : reportIdData[1];

        RestService.getReportDetails(reportId).then((reportDetails) => {
            const loggedUser = RestService.getProfile(),
                reportData = reportDetails.RESULT.RESPONSE.PrivateReportDetails;

            if (loggedUser.UserId !== reportData.OwnerId) {

                this._launchModal({
                    title: constants.MODAL_DELETE_REPORT_TITLE,
                    message: constants.MODAL_DELETE_NOT_ALLOWED_LABEL,
                    modalHeight: 130,
                    modalWidth: 350,
                    elm: elm
                });
                return;
            }

            const modalParams = {
                reportName: reportData.Name,
                reportId: reportId,
                reportLink: reportData.LinkId,
                versionList: reportData.VersionList.Version,
                groupId: `${elm.grouptype}_${reportId}`,
                groupType:elm.grouptype
            };

            let reportDeleteModal = new ReportDeleteModal({
                model: new Model(modalParams)
            });
            reportDeleteModal.render().then((result)=> { }).catch(err => console.log(err));
        });
    }

    undoReportFolder(name,groupId,groupTypeId,groupParentId,message){

        let targetToAddItem;
        if (groupTypeId === constants.FORMS_SHARED_GROUP_TYPE) {
            targetToAddItem = groupParentId ? $(`#well${groupParentId} UL`) : $(constants.SHARED_FORMS_CONTAINER + ' UL');
        } else {
            targetToAddItem = groupParentId ? $(`#well${groupParentId} UL`) : $(constants.EDIT_FORMS_SECTION_CONTAINER + ' UL');
        }

        const newNode = {
            node: {
                nodeName: name,
                icon: ICON_FOLDER,
                nodes: [],
                id: groupId,
                groupType: this.selectedGroupType,
                nodeType: 'group',
                hasChildren: false,
                parentId: groupParentId,
                toggleIcon: 'pf-carot-left',
                selected:true
            }
        };

        // clear other selections
        $('li[role="button"]').removeClass('bg-success');


        if (targetToAddItem.children() && $(targetToAddItem.children()[0]).text().trim() === 'no items') {
            $(targetToAddItem.children()[0]).remove();
        }

        // PF-3982: Fix for new folders on root level
        newNode.node.parentId = newNode.node.parentId || newNode.node.id;

        $(targetToAddItem[0]).append(singleItemTemplate(newNode));
        setTimeout(()=>{
            super.makeDroppables( this.expandUpdatedListOfPrivateNodes );
            super.attachRightClickMenu();
        },0);

        if (message){
            NotificationService.success( message );
        }
    }

    render() {
        super.render();
        //Default view comes from the Dashboard View.
    }
}

export default ReportLeftPanelView;
